// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2LmoA","resendInfoText":"OnGoingPaymentBox_resendInfoText__kXavr"};